import ROUTES from '../routes';
import TransactionsRisk from '../hoc/transactions-risk/transactions-risk';
import TransactionsRiskGeographical from '../hoc/transactions-risk/geographical/geographical';
import TransactionsRiskVolume from '../hoc/transactions-risk/volume-risk/transations';
import TransactionsRiskVolumeForm from '../hoc/transactions-risk/volume-risk/form';
import TransactionsRiskCalculation from '../hoc/transactions-risk/calculation/calculation';
import TransactionsTypesRiskScore from '../hoc/transactions-risk/types-scores/types-scores';
import CreateTransactionsTypesRiskScore from '../hoc/transactions-risk/types-scores/item';

const TransactionsRiskRoutes = {
  path: ROUTES.TRANSACTIONS_RISK,
  element: <TransactionsRisk />,
  children: [
    {
      path: ROUTES.TRANSACTIONS_RISK_GEOGRAPHICAL,
      element: <TransactionsRiskGeographical />,
    },
    {
      path: ROUTES.TRANSACTIONS_RISK_VOLUME_RISK,
      element: <TransactionsRiskVolume />,
      children: [
        {
          path: ROUTES.TRANSACTIONS_RISK_VOLUME_RISK_CREATE,
          element: <TransactionsRiskVolumeForm />,
        },
        {
          path: ROUTES.TRANSACTIONS_RISK_VOLUME_RISK_EDIT,
          element: <TransactionsRiskVolumeForm />,
        },
      ],
    },
    {
      path: ROUTES.TRANSACTIONS_RISK_CALCULATION,
      element: <TransactionsRiskCalculation />,
    },
    {
      path: ROUTES.TRANSACTIONS_RISK_TYPES_RISK,
      element: <TransactionsTypesRiskScore />,
      children: [
        {
          path: ROUTES.TRANSACTIONS_RISK_TYPES_RISK_CREATE,
          element: <CreateTransactionsTypesRiskScore />,
        },
        {
          path: ROUTES.TRANSACTIONS_RISK_TYPES_RISK_EDIT,
          element: <CreateTransactionsTypesRiskScore />,
        },
      ],
    },
  ],
};

export default TransactionsRiskRoutes;
